export const OPEN_ONBOARDING_FROM_INVITE_STORAGE_KEY =
  'compliance-portal-open-onboarding-from-invite';

export function markOpenOnboardingFromInvite(): void {
  sessionStorage.setItem(OPEN_ONBOARDING_FROM_INVITE_STORAGE_KEY, '1');
}

export function consumeOpenOnboardingFromInvite(): boolean {
  const value = sessionStorage.getItem(OPEN_ONBOARDING_FROM_INVITE_STORAGE_KEY);
  sessionStorage.removeItem(OPEN_ONBOARDING_FROM_INVITE_STORAGE_KEY);
  return value === '1';
}
